import angular from 'angular';
import 'ngclipboard';
import { logModule } from '../log.module.ts';
export const errorHandlerModule = 'sis-common.errorhandler';
"use strict";
(function () {
  angular.module(errorHandlerModule, ['sis-common.errorhandler.errorService', logModule, 'ngclipboard']);
})();